import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { HelpURLs } from '../../contact-us/contact-us.page';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements OnInit {

  helpURL: string;

  constructor(
    private mdlCtrl:ModalController,
    // private Location: Location,
    private router: Router,
    private flightService: ClubFlightService
  ) { }

  ngOnInit() {}

  back(){
    this.mdlCtrl.dismiss();
  }

  refreshHelpUrl() {
    // this.flightService.getHelp()
    //   .subscribe((helpURL: Array<HelpURLs>) => {
    //     if (helpURL && helpURL.length > 0) {
    //       this.helpURL = helpURL[0].url
    //     }

    //   }, (error) => {

    //   }, () => {
    //   })

  }


  callHelpPage() {
    this.flightService.getHelp()
      .subscribe((helpURL: any) => {
        if (helpURL && helpURL.length > 0) {
          // && helpURL.length > 0
          this.helpURL = helpURL[0].url;

          window.open(this.helpURL, '_self');
        }
      }, (error) => {

      }, () => {
      })
  
  }

  gotopage(Pagename) {    
    console.log('this.mdlCtrl: ', this.mdlCtrl);
    this.mdlCtrl.dismiss().then(()=>{
      this.router.navigate([Pagename])
    })
  }
}
